import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-menu-button',
    templateUrl: './menu-button.component.html',
    styleUrls: ['./menu-button.component.scss'],
    standalone: false
})
export class MenuButtonComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
